import React from 'react';
import ReactDOM from 'react-dom';
import DragObj from './drag';

//main_class和title_class都是类名
export const DragHoc = (InnerComponent, draggerId) =>
  class extends React.Component {
    drag_obj;
    componentDidMount() {
      this.init();
    }

    init = () => {
      setTimeout(() => {
        const child_node = ReactDOM.findDOMNode(this.refs.child); //获取到原生的dom元素
        const dragger = draggerId
          ? document.getElementById(draggerId)
          : child_node;
        if (child_node) {
          this.drag_obj = new DragObj(
            child_node,
            dragger,
            // main_class
            //   ? child_node.querySelector(`.${main_class}`)
            //   : child_node, //只拖拽类名为 ${main_class} 的div
            // title_class
            //   ? child_node.querySelector(`.${title_class}`)
            //   : child_node, //当鼠标按在类名为 ${title_class} 的div上时才允许拖拽
          );
        }
      }, 0);
    };

    componentWillUnmount() {
      if (this.drag_obj) {
        this.drag_obj.destroy();
      }
    }

    render() {
      return (
        <div ref='child' draggable='true'>
          <InnerComponent {...this.props} />
        </div>
      );
    }
  };
